import React from 'react';

if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}

type color = 'primary' | 'default' | 'secondry' | 'disabled' | 'default-disabled' | 'primary-disabled'

interface IButton {
    text: string,
    onClick?: () => any,
    extraClass?: string,
    color?: color,
    loading?: boolean 
}

const Button: React.FC<IButton> = ({ text, onClick, extraClass, color, loading }) => {
    const handleOnClick = () => {
        onClick && onClick();
    }
    return (
        <button onClick={() => handleOnClick()} className={`${color ? color + '-button' : 'default-button' } ${extraClass ? extraClass : ''}`}>
            {loading ? <span className="button-loading"></span> : text }
        </button>
    )
}

export default Button;
